module.exports = __webpack_public_path__ + "img/sofia_schmid_6.cc29106f.jpg";